module.exports = __webpack_public_path__ + "media/images/icons/icon-uncheck-7530ab03a87eb02c9bdc0227534bc84f.png";